import module from 'cliente/module.js'
import template from './template.html'

export class ClienteInformacionBancosListaItemComponent {
  idCliente
  data
  editar = false
  onChange

  cerrar (data) {
    if (data) {
      data.moneda = data.idMoneda === 1 ? 'MXN' : 'USD'
      this.data = {...this.data, ...data}
    }
    this.editar = false
  }

  eliminar () {
    this.onChange()
  }
}

module.component('clienteInformacionBancosListaItem', {
  controller: ClienteInformacionBancosListaItemComponent,
  template,
  bindings: {
    idCliente: '<',
    data: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/cliente/components/informacion/bancos/lista/item/component.js